import styles from "./Box.module.scss";
import { classNames } from "@/shared/lib/classNames/classNames";

interface IYear {
    year?: string;
    text: string;
}

interface BoxProps {
    title: string;
    yearList?: IYear[];
    textList?: IYear[];
    index: number;
}

export const Box = ({ title, yearList, textList, index }: BoxProps) => {
    return (
        <div className={styles.box}>
            <div className={styles.title}>
                <div className={styles.titleText}>{title}</div>
                <div
                    className={classNames(styles.titleIcon, {}, [
                        styles[`icon${index}`],
                    ])}
                />
            </div>
            <div className={styles.content}>
                {yearList &&
                    yearList.map((item, i) => (
                        <div className={styles.contentLine} key={item.year}>
                            <div className={styles.year}>{item.year}</div>
                            <div className={styles.text}>{item.text}</div>
                        </div>
                    ))}
                {textList &&
                    textList.map((item, i) => (
                        <ul className={styles.contentLine} key={i}>
                            <li className={styles.textFull}>{item.text}</li>
                        </ul>
                    ))}
            </div>
        </div>
    );
};
